import styled from "styled-components";
import { Select } from "@findemdev/maui";


export const Container = styled.div`
  margin: ${({ theme }) => `${theme.dimensions.spacing[3]} ${theme.dimensions.spacing[5]} 0px ${theme.dimensions.spacing[5]}`};
  padding-bottom: ${({ theme }) => theme.dimensions.spacing[3]};
  border-bottom: 1px solid ${({ theme }) => theme.colors['grey-300']};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.div``;

export const MyCompanyListTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${({ theme }) => theme.dimensions.spacing['1']};
`;

export const ActionsSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.dimensions['spacing']['1']};
`;

export const SelectCompWithMargin = styled(Select)`
  margin-right: ${({ theme: { dimensions } }) => dimensions.spacing[1]};
`;